function resetGpoSwatches() {
  document.querySelectorAll(".gpo-swatches input").forEach(input => {
    input.checked = false;
  });
}
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(resetGpoSwatches, 300);
});
window.addEventListener("pageshow", function (e) {
  if (e.persisted) {
    resetGpoSwatches();
  }
});